(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('UserGroupDetailController', UserGroupDetailController);

    UserGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'UserGroup', 'User', 'UserGroupAuthority', 'Company'];

    function UserGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, UserGroup, User, UserGroupAuthority, Company) {
        var vm = this;

        vm.userGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:userGroupUpdate', function(event, result) {
            vm.userGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
